import RegisterForm from "./RegisterForm";
import LandingPageContainer from "../LandingPageContainer";

function RegisterSimple() {
	return (
		<LandingPageContainer viewType="register">
			<RegisterForm viewType="register" isSimple={true} />
		</LandingPageContainer>
	);
}

export default RegisterSimple;
